const recountVaruablesCount = (parentBlock) => {
  const variablesList = parentBlock.querySelectorAll('.variables-property__block');

  variablesList.forEach((el, index) => {
    if (index < 4) el.classList.remove('hidden');
  });
};

const recountVariablesBlock = (parentBlock, elementSelector) => {
  const elementBlocks = parentBlock.querySelectorAll(elementSelector);
  let isActiveElementAdded = false;

  elementBlocks.forEach((elem, index) => {
    if (index < 5) {
      if (elem.classList.contains('_active')) isActiveElementAdded = true;
      elem.classList.remove('hidden');
    } else if (isActiveElementAdded && index === 5) elem.classList.remove('hidden');
    else if (!isActiveElementAdded && elem.classList.contains('_active')) elem.classList.remove('hidden');
  });
};

const init = () => {
  const variablesBlock = document.querySelector('.description-product__variables');

  if (variablesBlock) {
    recountVaruablesCount(variablesBlock);

    const colorsBlock = variablesBlock.querySelector('.variables-property__color-list');
    if (colorsBlock) recountVariablesBlock(colorsBlock, '.variables-property__color-value');
  }
};

init();

window.initVariables = init;
